var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "questionMessageRecord" },
    [
      _c(
        "van-notice-bar",
        {
          attrs: { mode: "closeable", background: "#333333", color: "#ffffff" }
        },
        [_vm._v(_vm._s(_vm.baseInfo.title))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "questionMessageRecord_topic" }, [
        _c(
          "div",
          { staticClass: "questionMessageRecord_topic_word" },
          [
            _c(
              "div",
              {
                staticClass: "questionMessageRecord_title",
                staticStyle: { "text-indent": "0", "margin-bottom": "8px" }
              },
              [_vm._v("\n\t\t\t\t正文：\n\t\t\t")]
            ),
            _vm._v("\n\t\t\t" + _vm._s(_vm.baseInfo.context) + "\n\t\t\t"),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "questionMessageRecord_topic_attachment" },
              [
                _vm._v("\n\t\t\t\t附件下载："),
                _vm._l(
                  _vm.computedParseName(_vm.baseInfo.attachmentAddress),
                  function(item, index) {
                    return _c("a", { key: index, attrs: { href: item.url } }, [
                      _vm._v(_vm._s(item.name))
                    ])
                  }
                )
              ],
              2
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "questionMessageRecord_title",
                staticStyle: { "text-indent": "0", "margin-bottom": "8px" }
              },
              [_vm._v("\n\t\t\t\t历史消息：\n\t\t\t")]
            ),
            _vm._v(" "),
            _vm._l(_vm.baseInfo.message, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "questionMessageRecord_content_item"
                },
                [
                  _c(
                    "div",
                    { staticClass: "questionMessageRecord_content_item_title" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(item.staffNo) +
                          " - " +
                          _vm._s(item.createTimeStr) +
                          " ：\n\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "questionMessageRecord_content_item_word" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(item.context) + "\n\t\t\t\t"
                      )
                    ]
                  )
                ]
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "questionMessageRecord_title" }, [
        _vm._v("我的回复：")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "questionMessageRecord_reply" }, [
        _c(
          "div",
          { staticClass: "questionMessageRecord_reply_word" },
          [
            _c("van-field", {
              attrs: {
                placeholder: "请填写您补充的消息说明",
                rows: "5",
                autosize: "",
                type: "textarea"
              },
              model: {
                value: _vm.content,
                callback: function($$v) {
                  _vm.content = $$v
                },
                expression: "content"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "questionMessageRecord_btns" }, [
        _c(
          "div",
          {
            staticClass: "questionMessageRecord_btns_cancel",
            on: { click: _vm.handleBack }
          },
          [_vm._v("\n\t\t\t取消\n\t\t")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "questionMessageRecord_btns_confirm",
            on: {
              click: function() {
                return _vm.handleReply()
              }
            }
          },
          [_vm._v("\n\t\t\t提交\n\t\t")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31687963", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31687963","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/question/message/record/index.vue
// module id = null
// module chunks = 